module.exports = "<bus-page></bus-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appFleet/bus.html
// module id = 1536
// module chunks = 0